module.exports = __webpack_public_path__ + "img/dodger-stadium_all-access.8488d961.jpg";